export default {"src":"/_next/static/media/tick.12aa3b2d.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};